<template>
  <v-container class="py-15">
    <div class="text-center">Fique por dentro das</div>
    <TitleWidget>{{ title }}</TitleWidget>

    <CarouselWidget class="my-10" :items="items" v-bind="carouselSettings" dots>
      <template #item="{ item }">
        <ArticleCard v-bind="item" :basePath="path" />
      </template>
    </CarouselWidget>

    <ButtonWidget to="/novidades" :align="'center'">Ver mais</ButtonWidget>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ArticleCard from "../cards/ArticleCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";

const _config = {
  mod: "articles",
  path: "/novidades",
  center: false,
};

const _pagination = {
  itemsPerPage: 3,
  returnTotalItems: 1,
};

const _carouselSettings = {
  itemsToShow: {
    xs: 1.2,
    sm: 2.5,
    md: 3,
    lg: 3,
    xl: 3,
  },
};

export default {
  data: () => ({
    loading: true,
    title: "Novidades",
    path: _config.path,
    totalItems: 0,
    carouselSettings: _carouselSettings,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      if (this.courseId) {
        params.courseId = this.courseId;
      }

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (params.returnTotalItems) {
              state.list = data.list;
              this.totalItems = data.totalItems;
            } else {
              state.list = data;
            }
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    ArticleCard,
    ButtonWidget,
    CarouselWidget,
  },
};
</script>
